import { KeycloakService } from "keycloak-angular";
import { AppConfigService } from "../services/config/app.config.service";

export function initializeKeycloak(keycloak: KeycloakService, appConf: AppConfigService) {
    
    return () => appConf.loadConfig().then((resp) =>
        keycloak.init({
            config: {
                realm: resp.realm,
                url: resp.ssoUrl,
                clientId: resp.clientId
            },
            initOptions: {
                onLoad: 'login-required',
                flow: 'standard',
                //  silentCheckSsoRedirectUri:
                //     window.location.origin + '/assets/silent-check-sso.html', 
                checkLoginIframe: false,
                responseMode: 'query'
            },
            loadUserProfileAtStartUp: false,
            enableBearerInterceptor: true,
            bearerExcludedUrls: ['/assets']
        })
    );
}